import { z } from "zod";

/**
 * Boundary schema for every sign-in step (`AuthResponse` in the OpenAPI document). Parsed with zod
 * because the session layer acts on it (stores tokens, routes to 2FA / verification).
 */
export const authStatusSchema = z.enum([
  "authenticated",
  "two_factor_required",
  "two_factor_enrollment_required",
  "verification_required",
]);

export const authResponseSchema = z.object({
  status: authStatusSchema,
  access_token: z.string().min(1).nullish(),
  expires_in: z.number().int().positive().nullish(),
  csrf_token: z.string().nullish(),
  challenge_id: z.string().nullish(),
  workspace_id: z.string().uuid().nullish(),
  totp_secret: z.string().nullish(),
  totp_uri: z.string().nullish(),
  backup_codes: z.array(z.string()).optional(),
  user: z
    .object({
      id: z.string(),
      email: z.string(),
      name: z.string(),
    })
    .passthrough()
    .nullish(),
});

export type AuthStatus = z.infer<typeof authStatusSchema>;
export type ParsedAuthResponse = z.infer<typeof authResponseSchema>;

/** An authenticated response always carries a token. */
export function hasAccessToken(response: ParsedAuthResponse): response is ParsedAuthResponse & { access_token: string } {
  return response.status === "authenticated" && typeof response.access_token === "string";
}
